import React, { memo } from "react";

import { QueueManagerTable } from "Components/QueueManagerTable/QueueManagerTable";

export const QueueManagerPage = memo(() => {
  return <QueueManagerTable />;
});
